import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=c1053e30&scoped=true"
import script from "./SystemSetting.vue?vue&type=script&lang=js"
export * from "./SystemSetting.vue?vue&type=script&lang=js"
import style0 from "./SystemSetting.vue?vue&type=style&index=0&id=c1053e30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1053e30",
  null
  
)

export default component.exports